/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {CreepyCarnivalTwoServerDataParser} from "../CreepyCarnivalTwoServerDataParser";
import {ICreepyCarnivalTwoInitData} from "./ICreepyCarnivalTwoServerData";
import {CreepyCarnivalTwoGameMode} from "../../gamemode/CreepyCarnivalTwoGameMode";

export class CreepyCarnivalTwoParsedInitData extends ParsedInitData {

    private readonly _respinPositionsAfter: any[];
    private readonly _specialSymbolsLength: number;
    private readonly _specialSymbolsArray: any[];
    private readonly _payoutWinMultiplier: number;
    private readonly _respinPlayed: number;
    private readonly _currentWinRatio: number;
    private readonly _isRestore: boolean;

    constructor(rawData: ICreepyCarnivalTwoInitData, dataParser: CreepyCarnivalTwoServerDataParser) {
        super(rawData, dataParser);

        this._isRestore = dataParser.parseIsRestoreState(rawData);
        this._respinPositionsAfter = dataParser.parseRespinPositionsAfter(rawData);
        this._specialSymbolsLength = dataParser.calculateSpecialSymbolsLength(rawData);
        this._specialSymbolsArray = dataParser.getSpecialSymbolsArray(rawData);
        this._payoutWinMultiplier = rawData.payoutWinMultiplier;
        this._respinPlayed = rawData.respinPlayed;
        this._currentWinRatio = rawData.currentWinRatio;
    }

    public get respinPositions(): any[] {
        return this._respinPositionsAfter;
    }

    public get specialSymbolsLength(): number {
        return this._specialSymbolsLength;
    }

    public get getSpecialSymbolsArray(): any[] {
        return this._specialSymbolsArray;
    }

    public get multiplier(): number {
        return this._payoutWinMultiplier;
    }

    public get respinsPlayedCount(): number {
        return this._respinPlayed;
    }

    public get currentWinRatio(): number {
        return this._currentWinRatio;
    }

    public get restore(): boolean {
        return this._isRestore;
    }

    protected isFeatureTotalWin(): boolean {
        return this.mode === CreepyCarnivalTwoGameMode.RESPIN || this.mode === CreepyCarnivalTwoGameMode.RESPIN_FREESPIN;
    }

    protected isNextFeatureTotalWin(): boolean {
        return this.nextMode === CreepyCarnivalTwoGameMode.RESPIN || this.nextMode === CreepyCarnivalTwoGameMode.RESPIN_FREESPIN;
    }
}